/* ============================================================
   hm-product-hero.js  -  hellomellow

   Progressive enhancement for the HM product hero:
   review-rating jump, variant gallery follow, and ajax add to cart.

   The plan radios are real form inputs named selling_plan, so with
   this file blocked or broken the form still submits natively and
   the correct plan still reaches the cart. This upgrades that to an
   ajax add so the drawer opens without a page reload.

   WHY DELEGATED
     one listener on the document cannot accumulate, and it works on
     markup added later by the theme editor.

   WHY IT USES THE THEME'S OWN DRAWER
     Be Yours opens its cart by calling renderContents on the mini-cart
     custom element after an ajax add. This follows that same native
     path. Pubsub is still sent when available for the theme's other
     cart listeners, but it is not used as the gate for opening the
     drawer. If mini-cart is absent, the form submits normally instead
     of silently failing.
   ============================================================ */
(function () {
  'use strict';

  var DONE_MS = 2200;

  function getMiniCart() {
    var cart = document.querySelector('mini-cart');
    if (!cart || typeof cart.renderContents !== 'function' || typeof cart.getSectionsToRender !== 'function') return null;
    return cart;
  }

  function getMiniCartAsync() {
    var cart = getMiniCart();
    if (cart) return Promise.resolve(cart);

    if (window.customElements && customElements.whenDefined) {
      return customElements.whenDefined('mini-cart').then(function () {
        return getMiniCart();
      });
    }

    return Promise.resolve(null);
  }

  function sectionsToRequest(miniCart) {
    return miniCart.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function canPublish() {
    return typeof publish === 'function' &&
           typeof PUB_SUB_EVENTS === 'object' &&
           PUB_SUB_EVENTS &&
           PUB_SUB_EVENTS.cartUpdate;
  }

  /* ---- review rating to verified reviews ----
     Claude's hero renders the stars/count as a div. Enhance that existing
     line into an accessible in-page link without changing Judge.me or
     duplicating the review system. */
  function wireRatings(scope) {
    var ratings = (scope || document).querySelectorAll('.hmph__rating');
    for (var i = 0; i < ratings.length; i++) {
      var rating = ratings[i];
      if (rating.dataset.hmphReviewLink === '1') continue;
      rating.dataset.hmphReviewLink = '1';
      rating.setAttribute('role', 'link');
      rating.setAttribute('tabindex', '0');
      rating.setAttribute('aria-label', 'Read verified reviews');
      rating.style.cursor = 'pointer';
    }
  }

  function goToReviews() {
    var target = document.getElementById('verified-reviews');
    if (!target) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#verified-reviews');
    } else {
      window.location.hash = 'verified-reviews';
    }
  }

  wireRatings(document);
  document.addEventListener('shopify:section:load', function (e) {
    wireRatings(e.target);
  });

  document.addEventListener('click', function (e) {
    var rating = e.target.closest && e.target.closest('.hmph__rating');
    if (!rating) return;
    e.preventDefault();
    goToReviews();
  });

  document.addEventListener('keydown', function (e) {
    var rating = e.target.closest && e.target.closest('.hmph__rating');
    if (!rating || (e.key !== 'Enter' && e.key !== ' ')) return;
    e.preventDefault();
    goToReviews();
  });

  /* ---- holiday gift wrap ----
     one click = one $8 wrap. the wrap line keeps its own quantity in cart,
     so 10 products + 1 wrap means one wrapped item. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hmph-gift-wrap]');
    if (!btn || btn.dataset.busy) return;

    e.preventDefault();

    var err = btn.parentElement && btn.parentElement.querySelector('[data-hmph-gift-wrap-err]');
    var original = btn.innerHTML;
    var root = btn.closest('[data-hmph]');
    var miniCart = getMiniCart();
    var miniCartReady = getMiniCartAsync();
    // The selected aroma is the visible variant radio. The input named id
    // is a hidden field, never :checked, so the old fallback always
    // returned the FIRST variant pane regardless of the selection.
    var variantInput = root && root.querySelector('input[data-hmph-variant-radio]:checked');
    if (!variantInput && root) variantInput = root.querySelector('input[name="id"]');
    var productVariantId = variantInput && variantInput.value;

    function showError(message) {
      if (!err) return;
      err.textContent = message;
      err.classList.add('is-on');
    }

    function clearError() {
      if (!err) return;
      err.textContent = '';
      err.classList.remove('is-on');
    }

    function localeRoot() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    function renderDrawer(state) {
      if (!miniCart) return;
      // The button lives on the PDP, under the drawer overlay, so the
      // drawer is closed or closing when this runs. renderContents patches
      // when open, renders fully when closed, and opens only if needed.
      if (state && state.sections && typeof miniCart.renderContents === 'function') {
        miniCart.renderContents(state);
      } else if (typeof miniCart.open === 'function') {
        miniCart.open();
      }
    }

    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.innerHTML = 'adding gift wrap...';
    clearError();

    if (!productVariantId) {
      btn.innerHTML = original;
      btn.disabled = false;
      delete btn.dataset.busy;
      showError('choose your aroma first.');
      return;
    }

    fetch(localeRoot() + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart could not be read');
        return response.json();
      })
      .then(function (cart) {
        if (!cart || !cart.item_count) {
          throw new Error('add your gift to the cart first.');
        }

        return fetch(localeRoot() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: 47215837085863,
              quantity: 1,
              properties: {
                '_gift_wrap_for': String(productVariantId)
              }
            }]
          })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data && (data.description || data.message) || 'could not add gift wrap.');
          }
          return data;
        });
      })
      .then(function () {
        return fetch(localeRoot() + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              'gift-wrapping': 'yes'
            },
            sections: ['mini-cart', 'cart-icon-bubble', 'mobile-cart-icon-bubble'],
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok) {
            throw new Error(data && (data.description || data.message) || 'gift wrap was added but the cart could not refresh.');
          }
          return data;
        });
      })
      .then(function (state) {
        return miniCartReady.then(function (readyCart) {
          miniCart = readyCart;
          renderDrawer(state);
          btn.innerHTML = 'gift wrap added';

          setTimeout(function () {
            btn.innerHTML = original;
            btn.disabled = false;
            delete btn.dataset.busy;
          }, 1600);
        });
      })
      .catch(function (error) {
        console.error('[hm-product-hero] gift wrap failed', error);
        btn.innerHTML = original;
        btn.disabled = false;
        delete btn.dataset.busy;
        showError(error && error.message ? error.message : 'could not add gift wrap. please try again.');
      });
  });

  /* ---- variant to gallery ----
     The only thing about the variant picker that needs javascript. Price,
     availability and the submitted id are all CSS, so with this blocked
     everything still works except the picture following the variant.
     Delegated, so it survives a theme editor re-render. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    if (input.name !== 'id' && !input.hasAttribute('data-hmph-variant-radio')) return;

    var root = input.closest('[data-hmph]');
    if (!root) return;

    var tag = root.querySelector('[data-hmph-variant-media]');
    if (!tag) return;

    var data;
    try { data = JSON.parse(tag.textContent); } catch (err) { return; }
    if (!data || !data.map) return;

    var slot = data.map[input.value];
    if (slot === undefined) return;

    /* the section id can contain characters querySelector treats as CSS
       syntax, for example template--21471301435559__hero. building a
       "#id" selector from it fails silently. matching on the attribute
       avoids escaping altogether. */
    var wanted = 'm-' + data.uid + '-' + slot;
    var radios = root.querySelectorAll('input[name^="hmph-media-"]');
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].id === wanted) {
        if (!radios[i].checked) radios[i].checked = true;
        break;
      }
    }
  });

  /* ---- holiday gift variant aroma UI ----
     One holiday gift product has eight aroma variants. These swatches are
     labels for the real variant radios, not links to separate products.
     Selecting one updates the visible aroma name, scent notes and feeling. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.hasAttribute('data-hmph-variant-radio')) return;
    var root = input.closest('[data-hmph]');
    if (!root || !root.querySelector('[data-holiday-aroma-swatches]')) return;

    var swatches = root.querySelectorAll('[data-holiday-aroma-swatches] .hmph__swatch');
    var current = null;
    for (var i = 0; i < swatches.length; i++) {
      var on = swatches[i].getAttribute('data-variant-id') === input.value;
      swatches[i].classList.toggle('is-on', on);
      if (on) current = swatches[i];
    }
    if (!current) return;

    var label = root.querySelector('[data-holiday-aroma-label]');
    var name = root.querySelector('[data-holiday-aroma-name]');
    var notes = root.querySelector('[data-holiday-aroma-notes]');
    var feeling = root.querySelector('[data-holiday-aroma-feeling]');
    var free = current.getAttribute('data-fragrance-free') === 'true';
    var aroma = current.getAttribute('data-aroma') || '';

    if (label) {
      if (free) {
        label.textContent = 'fragrance-free';
      } else {
        label.innerHTML = 'aroma · <span class="hmph__aroma-name" data-holiday-aroma-name></span>';
        var freshName = label.querySelector('[data-holiday-aroma-name]');
        if (freshName) freshName.textContent = aroma;
      }
    }
    if (notes) notes.textContent = current.getAttribute('data-notes') || '';
    if (feeling) feeling.textContent = current.getAttribute('data-feeling') || '';

    /* Holiday gift images are attached directly to each variant. Update the
       visible hero image from that variant media URL as a reliable fallback
       even if the gallery slot map has not re-rendered yet in the theme editor. */
    var holidayImage = current.getAttribute('data-variant-image');
    var holidayAlt = current.getAttribute('data-variant-alt') || aroma || '';
    if (holidayImage) {
      var visibleShot = root.querySelector('.hmph__stage .hmph__shot img');
      if (visibleShot) {
        visibleShot.src = holidayImage;
        visibleShot.srcset = holidayImage + ' 1600w';
        visibleShot.alt = holidayAlt;
      }
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.classList || !form.classList.contains('hmph__form')) return;

    // This hero must never send the shopper to /cart. Wait for the
    // native mini-cart custom element, then use its normal drawer path.
    e.preventDefault();

    var btn = form.querySelector('[data-hmph-add]');
    var box = form.querySelector('[data-hmph-err]');

    getMiniCartAsync().then(function (miniCart) {
      if (!miniCart) {
        if (box) {
          box.textContent = 'the cart drawer is still loading. please try again.';
          box.classList.add('is-on');
        }
        return;
      }
      add(form, miniCart);
    });
  });

  function add(form, miniCart) {
    var btn = form.querySelector('[data-hmph-add]');
    var box = form.querySelector('[data-hmph-err]');
    if (!btn || btn.dataset.busy) return;

    var variant = form.querySelector('input[name="id"]');
    if (!variant || !variant.value) return;

    var plan = form.querySelector('input[name="selling_plan"]:checked');
    var item = { id: parseInt(variant.value, 10), quantity: 1 };
    // an empty value is the one-time option. omit the key entirely
    // rather than sending a blank one.
    if (plan && plan.value) item.selling_plan = parseInt(plan.value, 10);

    var label = btn.innerHTML;
    btn.dataset.busy = '1';
    btn.disabled = true;
    btn.textContent = 'adding...';
    if (box) { box.textContent = ''; box.classList.remove('is-on'); }

    var sections = sectionsToRequest(miniCart);

    fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [item],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          fail(btn, box, label, (res.data && (res.data.description || res.data.message)) || null);
          return;
        }

        // This is the same direct drawer path used by the theme's native
        // product-form.js. Open immediately from the bundled section HTML.
        try {
          miniCart.renderContents(res.data);
        } catch (renderErr) {
          console.error('[hm-product-hero] cart drawer render failed', renderErr);
          if (typeof miniCart.open === 'function') miniCart.open();
        }
        btn.innerHTML = 'added to cart';
        setTimeout(function () { reset(btn, label); }, DONE_MS);

        // Keep the existing full-cart event for any hellomellow listeners,
        // but never make the drawer wait on this second request.
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = res.data.sections || {};
            if (canPublish()) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'hm-product-hero',
                cart: cart,
                sections: sections
              });
            }
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          })
          .catch(function () {
            // The item is already added and the drawer is already open.
            // A secondary event refresh failure must not report a false
            // add-to-cart error to the customer.
          });
      })
      .catch(function () { fail(btn, box, label, null); });
  }

  function fail(btn, box, label, msg) {
    reset(btn, label);
    if (!box) return;
    box.textContent = msg || 'could not add that to the cart. please try again.';
    box.classList.add('is-on');
  }

  function reset(btn, label) {
    btn.innerHTML = label;
    btn.disabled = false;
    delete btn.dataset.busy;
  }
})();

/* kiddo body butter .5 oz gallery hotfix.
   the shared hero renders the first eight product media items. the .5 oz
   variant's real featured image currently sits ninth in shopify, so it
   needs one extra gallery slot in preview without reordering live product
   media. scoped to this product and this exact real variant only. */
(function () {
  'use strict';

  var HALF_VARIANT = '51327097405607';
  var HALF_IMAGE = 'https://cdn.shopify.com/s/files/1/0587/9778/5255/files/hellomellow_kiddo_5oz_bum_and_body_butter.jpg?v=1789137112';

  function isKiddoButter() {
    return /\/products\/kiddo-body-butter(?:[/?#]|$)/.test(window.location.pathname);
  }

  function ensureHalfSlot(root) {
    var existing = root.querySelector('[data-hmph-half-media]');
    if (existing) return existing;

    var tag = root.querySelector('[data-hmph-variant-media]');
    var stage = root.querySelector('.hmph__stage');
    if (!tag || !stage) return null;

    var data;
    try { data = JSON.parse(tag.textContent); } catch (err) { return null; }
    if (!data || !data.uid) return null;

    var firstMediaRadio = root.querySelector('input[name^="hmph-media-"]');
    if (!firstMediaRadio) return null;

    var radio = document.createElement('input');
    radio.className = 'hmph__sr-input';
    radio.type = 'radio';
    radio.name = firstMediaRadio.name;
    radio.id = 'm-' + data.uid + '-kiddo-half';
    radio.setAttribute('data-hmph-half-media', '');
    stage.parentNode.insertBefore(radio, stage);

    var shot = document.createElement('div');
    shot.className = 'hmph__shot hmph__shot--kiddo-half';
    shot.innerHTML = '<img src="' + HALF_IMAGE + '" width="1200" height="1200" loading="eager" alt="hellomellow kiddo .5oz bum and body butter">';
    stage.appendChild(shot);

    var style = document.createElement('style');
    style.textContent = '#' + radio.id + ':checked ~ .hmph__stage .hmph__shot{display:none}#' + radio.id + ':checked ~ .hmph__stage .hmph__shot--kiddo-half{display:block}';
    root.appendChild(style);

    return radio;
  }

  document.addEventListener('change', function (e) {
    if (!isKiddoButter()) return;
    var input = e.target;
    if (!input || input.type !== 'radio') return;
    if (input.name !== 'id' && !input.hasAttribute('data-hmph-variant-radio')) return;
    if (String(input.value) !== HALF_VARIANT) return;

    var root = input.closest('[data-hmph]');
    if (!root) return;
    var radio = ensureHalfSlot(root);
    if (radio) radio.checked = true;
  });
})();
